import { jsx as _jsx } from "react/jsx-runtime";
import Landing from "@/components/Landing/adminjs/Landing";
const LandingPage = (param)=>{
    let { landing , error  } = param;
    if (!landing || error) return null;
    return /*#__PURE__*/ _jsx(Landing, {
        landing: landing
    });
};
export var __N_SSP = true;
export default LandingPage;
